import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import nftDetailReducer from "./nftDetailSlice";

const reducers = combineReducers({
  nftData: nftDetailReducer,
});

const persistConfig = {
  key: "bitflexmine",
  storage,
  blacklist: [],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [],
});

export default store;
